import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useGetQuery, usePostQuery } from 'hooks'
import { Card, Icon, PaginateTable, Row } from 'components'
import { spriteImagePath } from '../../games/pinmonkey/config/constants'

export const AdminNpcs = () => {
  const [page, setPage] = useState({ page: 1, limit: 25 })
  const navigate = useNavigate()
  const offset = (page.page - 1) * page.limit

  const { data, isFetching, refetch } = useGetQuery({
    url: `/admin/npcs?limit=${page.limit}&offset=${offset}`,
  })
  const { post: deleteNpc } = usePostQuery({ method: 'DELETE' })

  const npcs  = data?.npcs?.rows ?? []
  const count = data?.npcs?.count ?? 0

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this NPC?')) return
    await deleteNpc(null, `/admin/npcs/${id}`)
    refetch()
  }

  return (
    <Card>
      <Row>
        <PaginateTable
          data={npcs}
          count={count}
          loading={isFetching}
          columns={[
            {
              title: '',
              key: 'sprite',
              render: (sprite) => sprite
                ? <img src={spriteImagePath(sprite)} alt={sprite} style={{ width: 28, height: 28, imageRendering: 'pixelated', objectFit: 'contain' }} />
                : null,
            },
            { title: 'Name',       key: 'name' },
            { title: 'Sprite',     key: 'sprite', render: (v) => v || '—' },
            { title: 'Stationary', key: 'stationary', render: (v) => v ? 'Yes' : 'No' },
            {
              title: 'Actions',
              key: 'id',
              className: 'right',
              render: (id) => (
                <>
                  <span
                    style={{ marginRight: '0.75rem', cursor: 'pointer' }}
                    onClick={() => navigate(`/admin/npcs/${id}/edit`)}
                  >
                    <Icon icon="pencil" />
                  </span>
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDelete(id)}
                  >
                    <Icon icon="delete-outline" />
                  </span>
                </>
              ),
            },
          ]}
          addItem={() => navigate('/admin/npcs/new')}
          onPageChange={setPage}
        />
      </Row>
    </Card>
  )
}
